export default __webpack_public_path__ + "static/media/wfh-dark.11815121.svg";